class InitSwiper {
  constructor(target, options) {
    this.target = target;
    this.options = options;
  }
    
/* 初期化メソッド */
  init() {
    const swiper = new Swiper(this.target, this.options);
    return swiper;
  }
}

// グローバル変数として定義
window.InitSwiper = InitSwiper;